exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".template-form[data-v-7afa35bb]{max-width:720px}.form-hint[data-v-7afa35bb]{color:#909399;font-size:12px;line-height:1.5}.readonly-text[data-v-7afa35bb]{color:#606266}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-7afa35bb&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/OperationManage/UserAdminister/ShareTemplate/ShareTemplateDetail.vue
// module id = 586
// module chunks = 0